import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface QuickReplyOption {
  label: string;
  value: string;
  emoji?: string;
}

interface AccessibilitySettings {
  highContrast: boolean;
  largeText: boolean;
  highlightLinks: boolean;
}

interface QuickReplyButtonsProps {
  options: QuickReplyOption[];
  onSelect: (value: string) => void;
  accessibility?: AccessibilitySettings;
}

export function QuickReplyButtons({ options, onSelect, accessibility }: QuickReplyButtonsProps) {
  const highContrast = accessibility?.highContrast;
  const largeText = accessibility?.largeText;

  return (
    <motion.div
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      className="flex flex-wrap gap-2 mt-3"
    >
      {options.map((option, index) => (
        <motion.div
          key={option.value}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.1 * index }}
        >
          <Button
            variant="outline"
            size="sm"
            onClick={() => onSelect(option.value)}
            className={cn(
              "transition-all duration-200",
              largeText ? "text-sm" : "text-xs",
              highContrast 
                ? "bg-white text-black border-white hover:bg-yellow-400 hover:text-black hover:border-yellow-400" 
                : "bg-background/80 hover:bg-primary hover:text-primary-foreground"
            )}
          >
            {option.label}
          </Button>
        </motion.div>
      ))}
    </motion.div>
  );
}
